enum NamespaceEnum {
  //系统管理
  SysUser = 'sys/user',
  Menu = 'sys/menu',
  Role = 'sys/role',
  // 业务管理
  Config = 'sys/config',
  FunctionalGroup = 'functionalGroup',
  Inquiry = 'inquiry',
  Order = 'order',
  OrderDetail = 'orderDetail',
  Product = 'product',
  StructuralCategory = 'structuralCategory',
  ClientUser = 'clientUser',
  Feeback = 'feeback',
  Tag = 'tag',
  TextConfig = 'textConfig',
  Advertisement = 'advertisement',
  NumberDetail = 'numberDetail',
  FileDetail = 'fileDetail',
  ContactUs = 'contactUs',
  Function = 'function',
  PriceData = 'priceData',
  Dept = 'sys/dept',
  DictData = 'sys/dict/data',
  DictType = 'sys/dict',
  JobLog = 'jobLog',
  Job = 'sys/job',
  LikeRecord = 'likeRecord',
  News = 'news',
  SportRecord = 'sportRecord',
  SportSeasonRecord = 'sportSeasonRecord',
  ProductSpecification = 'productSpecification',
  Image = 'image',
  Video = 'video',
  AreaClub = 'areaClub',
  Match = 'match',
  Banner = 'banner',
  Ad = 'ad',
  ClubPlayer = 'clubPlayer',
  PlayerCertificate='playerCertificate',
  MatchPlayer='matchPlayer',
  ClubImage='clubImage',
  MatchRule='matchRule',
  Area='area',
  AreaVenue='areaVenue',
  MatchShow='matchShow',
  MatchLevel='matchLevel',
  AreaImage='areaImage',
  Task = "task",
  UserTask = "userTask",
  ClientGroup = "clientGroup",
  ScoreShop = "scoreShop",
  ScoreExchange = "scoreExchange",
  Address = "address",
  Cart = "cart",
  Collect = "collect",
  Good = "good",
  /** 分类分页接口路径为 goodCategoryId/list/page */
  GoodCategoryId = "goodCategoryId",
  GoodCategory = "goodCategory",
  GoodReturn = "goodReturn",
  Pay = "pay",
  Notice = "sys/notice",
}

export default NamespaceEnum;
